import { Component, Inject, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ColorService } from '@app/shared/services/color.service';
import { TrackerService } from '@app/shared/services/tracker.service';
import { TrackingEventArgs } from '@app/shared/services/tracking.model';
import { WindowToken } from '@app/shared/window.token';

@Component({
  selector: 'dgx-parsed-resume-indicator',
  templateUrl: './parsed-resume-indicator.component.html',
  styleUrls: ['./parsed-resume-indicator.component.scss'],
})
export class ParsedResumeIndicator implements OnInit {
  // Bindings
  @Input() public hasParsedResume: boolean = true;
  @Input() public ownerKey: number;

  // Local
  public i18n = this.translate.instant([
    'dgProfileOverview_HasParsedResume',
    'dgProfileOverview_NoParsedResume',
    'Core_Upload',
    'Onboarding_UploadResumeHeader',
  ]);

  public indicatorText: string;
  public completedImg = '/content/img/circle-check-green.svg';

  public progressCircleInProgress = this.ColorSvc.getColor('pending');
  public progressCircleTrailColor = this.ColorSvc.getColor('ebony-a08');

  constructor(
    private translate: TranslateService,
    private ColorSvc: ColorService,
    private tracker: TrackerService,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  public ngOnInit(): void {
    this.indicatorText = this.hasParsedResume
      ? this.i18n.dgProfileOverview_HasParsedResume
      : this.i18n.dgProfileOverview_NoParsedResume;
  }

  public trackGoToResumeParsing(): void {
    this.trackEvent('Resume Parsing Initiated', {
      ProfileOwnerId: this.ownerKey,
    });
    this.windowRef.open('/getstarted/resume', '_self');
  }

  private trackEvent(
    action: string,
    properties?: { [name: string]: any }
  ): void {
    let data: TrackingEventArgs = { action };
    // add properties, if defined
    if (properties) {
      data = {
        ...data,
        properties,
      };
    }
    // track event data
    this.tracker.trackEventData(data);
  }
}
